import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-infrastructure-feedback-list',
  templateUrl: './infrastructure-feedback-list.component.html',
  styleUrls: ['./infrastructure-feedback-list.component.scss']
})
export class InfrastructureFeedbackListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists =[];

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/studentinfrastructurefeedback/').subscribe(
      data => {
        this.lists = data.data;
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }

}
